import * as React from 'react';
import PropTypes from 'prop-types';

import { CarouselContext } from './CarouselContext';
import Button from 'components/Button';

export default function CarouselControl({ label, type, ...props }) {
  const context = React.useContext(CarouselContext);

  if (!context) {
    // Handle error
    return null;
  }

  const { state, ...carousel } = context;

  switch (type) {
    case 'next': {
      return (
        <Button
          aria-label="Show next item"
          disabled={state.isEnd}
          onClick={() => carousel.next()}
          size="sm"
          variant="quaternary"
          {...props}
        >
          →
        </Button>
      );
    }
    case 'previous': {
      return (
        <Button
          aria-label="Show previous item"
          disabled={state.isStart}
          onClick={() => carousel.previous()}
          size="sm"
          variant="quaternary"
          {...props}
        >
          ←
        </Button>
      );
    }
    default: {
      return null;
    }
  }
}

CarouselControl.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['next', 'previous']),
};
